import React from 'react';
import { useRecordContext } from 'react-admin';
import { ChannelState } from 'constants/channel-state.enum';
import GppBadRounded from '@mui/icons-material/GppBadRounded';
import GppGoodRounded from '@mui/icons-material/GppGoodRounded';

export function Health() {
  const record = useRecordContext() || {};
  const { overallGoodStanding, state, regularCheckRequired } = record;
  if ([ChannelState.CUSTOMER, ChannelState.DEMONETIZED].includes(state)) {
    if (!overallGoodStanding) {
      return (
        <GppBadRounded sx={{
          color: 'error.main',
        }}
        />
      );
    }
  }
  if (!overallGoodStanding) {
    return (
      <GppBadRounded sx={{
        color: 'grey.400',
      }}
      />
    );
  }
  if (regularCheckRequired) {
    return (
      <GppGoodRounded sx={{
        color: 'orange',
      }}
      />
    );
  }

  return (
    <GppGoodRounded sx={{
      color: state === ChannelState.CUSTOMER ? 'success.main' : 'grey.500',
    }}
    />
  );
}

Health.defaultProps = {
  label: 'Health',
};
